import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './eligibilityPucExam.component.html',
	styleUrls: ['./eligibilityPucExam.component.css']
})

export class EligibilityPucExamComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/admission/eligibilityPucExam.component.ts